export default {
      id: "google-maps-usage",
      viewBox: "0 0 2048 2048",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#google-maps-usage",
      toString: function () {
        return this.url;
      }
    }